// extracted by mini-css-extract-plugin
export default {"chartContainer":"ReportChartSkeleton_chartContainer__cgWjT","shimmer":"ReportChartSkeleton_shimmer__gw5m1"};